export class Agregat {
    public subDomain: string;
    public domain: String;
    public color: String;
    public total: number;

    constructor() {
        this.subDomain = '';
        this.domain = null;
        this.total = 0;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/stat/stat-graph/agregat.model.ts